module.exports = __webpack_public_path__ + "static/img/ss5-2.f1b658d2.png";